import { render, staticRenderFns } from "./AdminArticle.vue?vue&type=template&id=56cd617e&scoped=true&"
import script from "./AdminArticle.vue?vue&type=script&lang=js&"
export * from "./AdminArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cd617e",
  null
  
)

export default component.exports